import React, { useEffect, useState } from "react";
import {
  EmailIcon,
  EmailShareButton,
  FacebookShareButton,
  TwitterShareButton,
  WhatsappIcon,
  WhatsappShareButton,
} from "react-share";
import { FacebookIcon, TwitterIcon } from "react-share";
import { Modal } from "react-bootstrap";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { useToaster } from "src/_common/hooks/actions/common/appToasterHook";
import { useAppUserDetailsSelector } from "src/_common/hooks/selectors/userSelector";
import { camelCase } from "lodash";

interface ShareModalProps {
  onClose: () => void;
  shouldShow: boolean;
  performanceDetails: any;
  url?: any;
}

const ShareModal = ({ onClose, shouldShow, performanceDetails, url }: ShareModalProps) => {
  const toast = useToaster();
  const userDetails = useAppUserDetailsSelector();

  const [isCopied, setIsCopied] = useState<boolean>(false);

  useEffect(() => {
    if (isCopied) {
      toast.success("Link copied successfully");
      // setIsCopied(false)
    }
  }, [isCopied]);

  //useEffect(() => {}, [shouldShow]);

  return (
    <Modal
      show={shouldShow}
      backdrop="static"
      keyboard={false}
      className="share-modal"
      centered
      contentClassName="custom-modal"
    >
      <Modal.Header>
        <h2 className="modal-header-text">Share Link</h2>
        <button
          type="button"
          className="btn-close"
          onClick={() => {
            onClose();
            setIsCopied(false);
          }}
        ></button>
      </Modal.Header>
      <Modal.Body>
        <div className="modal-share">
          {/* <>{console.log(`${SHARE_URL}${btoa(`id=${shareID}&type=${section}&cryptId=${id}&baseUrl=${window.location.origin}/`)}`)}</> */}
          <FacebookShareButton
            quote={
              (userDetails?.display_name || userDetails?.first_name
                ? (userDetails?.display_name || (userDetails?.first_name && camelCase(userDetails?.first_name + ""))) +
                  "'s "
                : "") +
              performanceDetails?.title +
              " Team"
            }
            url={url}
            className="Demo__some-network__share-button"
          >
            <FacebookIcon size={32} round /> Facebook share
          </FacebookShareButton>

          <TwitterShareButton
            title={
              (userDetails?.display_name || userDetails?.first_name
                ? (userDetails?.display_name || (userDetails?.first_name && camelCase(userDetails?.first_name + ""))) +
                  "'s "
                : "") +
              performanceDetails?.title +
              " Team"
            }
            url={url}
          >
            <TwitterIcon size={32} round />
            Twitter share
          </TwitterShareButton>

          <WhatsappShareButton
            title={
              (userDetails?.display_name || userDetails?.first_name
                ? (userDetails?.display_name || (userDetails?.first_name && camelCase(userDetails?.first_name + ""))) +
                  "'s "
                : "") +
              performanceDetails?.title +
              " Team"
            }
            url={url}
          >
            <WhatsappIcon size={32} round />
            Whatsapp share
          </WhatsappShareButton>

          <EmailShareButton
            body={
              (userDetails?.display_name || userDetails?.first_name
                ? (userDetails?.display_name || (userDetails?.first_name && camelCase(userDetails?.first_name + ""))) +
                  "'s "
                : "") +
              performanceDetails?.title +
              " Team"
            }
            url={url}
          >
            <EmailIcon size={32} round />
            Email share
          </EmailShareButton>

          <CopyToClipboard text={url} onCopy={() => setIsCopied(true)}>
            <button className="fa-copy-btn">
              <i className="fa fa-copy"></i>Copy Link
            </button>
          </CopyToClipboard>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ShareModal;
